import { defineStore } from 'pinia'
import { LangType } from '@/i18n'

export interface CurrentCountryType {
  key: string
  label: string
}

export interface CurrentLanguageType {
  key: LangType
  label: string
}

export const useLanguageStore = defineStore('__mall_language__', {
  state: (): {
    currentCountry: CurrentCountryType
    currentLanguage: CurrentLanguageType
  } => ({
    currentCountry: {
      key: 'other',
      label: 'other'
    },
    currentLanguage: {
      key: 'zh',
      label: '中文'
    }
  }),
  actions: {
    setCurrentCountry(country: CurrentCountryType) {
      console.log('currentCountry', country)
      this.currentCountry = country
    },
    setCurrentLanguage(language: CurrentLanguageType) {
      this.currentLanguage = language
    }
  },
  persist: {
    key: '__mall_language__',
    storage: localStorage,
    paths: ['currentLanguage', 'currentCountry']
  }
})
